import { render, staticRenderFns } from "./InvoiceElementSelector.vue?vue&type=template&id=241380d0&"
import script from "./InvoiceElementSelector.vue?vue&type=script&lang=js&"
export * from "./InvoiceElementSelector.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceElementSelector.vue?vue&type=style&index=0&id=241380d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports